export default "__VITE_ASSET__C96lK3xQ__"